import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { usePianoProfileActions } from '@/hooks/store/use-piano-profile-store';
import { useMeasureActions } from '@/hooks/store/use-measure-store';
import { useDesignActions } from '@/hooks/store/use-design-store';
import { useMeasureOptionsActions } from '@/hooks/store/use-measure-options-store';
export const useCreateNewProfile = () => {
  const $ = _c(8);
  const {
    reset: resetPianoProfile,
    updateSingleState
  } = usePianoProfileActions();
  const {
    reset: resetMeasures
  } = useMeasureActions();
  const {
    reset: resetDesign
  } = useDesignActions();
  const {
    reset: resetMeasureOptions
  } = useMeasureOptionsActions();
  let t0;
  if ($[0] !== resetDesign || $[1] !== resetMeasureOptions || $[2] !== resetMeasures || $[3] !== resetPianoProfile || $[4] !== updateSingleState) {
    t0 = (pianoBrand, pianoModel, onSuccess) => {
      resetPianoProfile();
      resetMeasures();
      resetDesign();
      resetMeasureOptions();
      if (pianoBrand.trim()) {
        updateSingleState("brand", pianoBrand.trim());
      }
      if (pianoModel.trim()) {
        updateSingleState("model", pianoModel.trim());
      }
      onSuccess?.();
    };
    $[0] = resetDesign;
    $[1] = resetMeasureOptions;
    $[2] = resetMeasures;
    $[3] = resetPianoProfile;
    $[4] = updateSingleState;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const createNewProfile = t0;
  let t1;
  if ($[6] !== createNewProfile) {
    t1 = {
      createNewProfile
    };
    $[6] = createNewProfile;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};